import Vue from "vue";
import Vuex from "vuex";
import { getToken, setToken, removeToken } from "@/utils/auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: getToken() || "",
    user: null,
    roles: [],
    /** 门户登录弹层是否显示（不跳转独立登录页） */
    portalLoginVisible: false,
    /** 登录成功后跳转路径 */
    portalLoginRedirect: "",
  },
  mutations: {
    SET_TOKEN(state, t) {
      state.token = t;
      setToken(t);
    },
    SET_USER(state, u) {
      state.user = u;
    },
    SET_ROLES(state, r) {
      state.roles = r;
    },
    LOGOUT(state) {
      state.token = "";
      state.user = null;
      state.roles = [];
      removeToken();
    },
    OPEN_PORTAL_LOGIN(state, redirect) {
      state.portalLoginVisible = true;
      state.portalLoginRedirect = redirect || "";
    },
    CLOSE_PORTAL_LOGIN(state) {
      state.portalLoginVisible = false;
      state.portalLoginRedirect = "";
    },
  },
  actions: {},
});
